import { render, staticRenderFns } from "./trust-deed-invoice-dialog.vue?vue&type=template&id=0d633770"
import script from "./trust-deed-invoice-dialog.vue?vue&type=script&lang=js"
export * from "./trust-deed-invoice-dialog.vue?vue&type=script&lang=js"
import style0 from "./trust-deed-invoice-dialog.vue?vue&type=style&index=0&id=0d633770&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports